import { render } from "./ViewMoreDetailsView.vue?vue&type=template&id=c3300d6e&ts=true"
import script from "./ViewMoreDetailsView.vue?vue&type=script&lang=ts"
export * from "./ViewMoreDetailsView.vue?vue&type=script&lang=ts"

import "./ViewMoreDetailsView.vue?vue&type=style&index=0&id=c3300d6e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__